import React, { useEffect, useState } from "react";
import { ArrowsClockwise, PauseCircle, Warning } from "@phosphor-icons/react";

const ago = (iso) => {
  if (!iso) return "not yet";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  return s < 45 ? "just now" : s < 3600 ? `${Math.round(s / 60)} min ago` : `${Math.round(s / 3600)} h ago`;
};

export function SyncBadge({ sync }) {
  const [, tick] = useState(0);
  useEffect(() => { const id = setInterval(() => tick((n) => n + 1), 15000); return () => clearInterval(id); }, []);
  if (!sync) return null;
  const checking = sync.status === "running";
  const [Icon, cls, text] = sync.limit_message ? [Warning, "text-red-300", sync.limit_message]
    : !sync.auto ? [PauseCircle, "text-neutral-500", "Auto-check is off on this copy of the app · use the button to check"]
    : [ArrowsClockwise, "text-neutral-400", `${checking ? "Checking Monday.com now…" : `Checked Monday.com ${ago(sync.last_sync_at)}`} · checks every minute`];
  return <span className={`text-xs flex items-center gap-1.5 ${cls}`} data-testid="wi-approvals-sync-badge"><Icon size={14} className={checking ? "animate-spin" : ""} />{text}</span>;
}
